export default class {

    branches = null;

    constructor(dto) {
        this.Branch = dto.Branch;
        this.RegionCode = dto.RegionCode;
    }

    mapFromDto(branches) {
        
        branches.forEach(branch => {
            branch.Regions = [{ Id: null, Name: 'Любая', Codes: null}, ...branch.Regions];
        });
        this.branches = branches;

        this.Branch = branches.find(e => e.Name == this.Branch);
        this.RegionCode = this.Branch.Regions.find(e => this.RegionCode == null && e.Codes == null || e.Codes != null && e.Codes.some(c => c == this.RegionCode));
    }

    isValid() {
        return Boolean(this.Branch) && Boolean(this.RegionCode);
    }

    mapToDto() {
        return {
            Branch: this.Branch.Name,
            RegionCode: this.RegionCode.Codes
        };
    }
}